import type { SalesReportResponse } from "@gioia365/contracts";
import { useId } from "react";
import { useT } from "../i18n/locale";
import { KpiTable, type KpiRow, type KpiTableGroup } from "./KpiTable";

// «Una riga per Commerciale» (piano M7, Task 3; mock-up `teamSection`): soltanto per chi vede il team (SEZ-1), una riga per persona
// (con «Tutto il team» ogni persona di «Di chi», anche a zero; con persone scelte le scelte) e, con più di una riga, il totale, i cui
// Lead diversi il server conta una volta sull'unione. Le colonne partono da «Sintesi»; le schede, sotto 860 px, partono aperte.

type Props = {
  /** La risposta di `GET /api/reports/sales` con `byPerson`. */
  report: SalesReportResponse;
  /** Il periodo scritto, per la didascalia. */
  range: string;
  /** Il gruppo di colonne scelto, nello stato della pagina. */
  group: KpiTableGroup;
  onGroupChange: (group: KpiTableGroup) => void;
};

export function TeamSection({ report, range, group, onGroupChange }: Props) {
  const t = useT();
  const titleId = useId();
  if (report.byPerson === null) return null;
  const rows: KpiRow[] = report.byPerson.map(({ person, metrics }) => ({
    key: person.membershipId,
    label: person.displayName,
    ...(person.active ? {} : { sub: t("reports.controls.inactive") }),
    metrics,
  }));
  if (rows.length > 1) {
    rows.push({
      key: "total",
      label: report.chosen.length > 0 ? t("reports.team.totalChosen") : t("reports.team.total"),
      sub: t("reports.table.countedOnce"),
      metrics: report.totals.current,
      total: true,
    });
  }
  return (
    <section className="g-report-section" aria-labelledby={titleId}>
      <KpiTable
        heading={
          <>
            <h2 id={titleId}>{t("reports.team.title")}</h2>
            <p className="g-report-hint">{t("reports.team.intro")}</p>
          </>
        }
        caption={t("reports.team.caption", { range })}
        firstHead={t("reports.team.firstHead")}
        groupsLabel={t("reports.team.groupsLabel")}
        rows={rows}
        targets={report.targets}
        openCards
        group={group}
        onGroupChange={onGroupChange}
        wideNote={t("reports.table.wideNote")}
      />
    </section>
  );
}
